"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_acceleration_hi__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 105.25,
    y1: 96.98,
    x2: 105.25,
    y2: 96.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 87.42,
    y1: 126.3,
    x2: 174.03,
    y2: 126.3,
    xlinkHref: "#linear-gradient"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.4,114.31a1.6,1.6,0,0,1-.05.21",
    transform: "translate(0 0)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_Box",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77,148.46A79.53,79.53,0,1,1,175.53,96a79.31,79.31,0,0,1-19.76,52.46",
    transform: "translate(0 0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.43,81.31H128.2a44.86,44.86,0,0,0-86.54,0h-.17C48,57.86,70.18,40.53,96.54,40.53S145.1,57.86,151.6,81.31",
    transform: "translate(0 0)",
    style: {
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.83,53.57a58.13,58.13,0,0,1,32.71-10c25.21,0,46.58,15.85,54.1,37.73h1c-6.5-23.45-28.69-40.78-55.06-40.78S48,57.86,41.49,81.31h.17A44.77,44.77,0,0,1,63.83,53.57Z",
    transform: "translate(0 0)",
    style: {
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.25,97",
    transform: "translate(0 0)",
    style: {
      opacity: 0.200000002980232,
      isolation: "isolate",
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "d1c88cd9-0bb1-45f4-bea1-e6a7e7ba60e5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a9111d72-d602-4fa9-b38f-0c9ebea0453c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d5cc117b-b5e1-4602-8440-e8b86e252a26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f4ca176c-e707-4b99-be62-cd0a1ff88bd0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e62e96c4-2b15-4645-a046-12d99cad03ea"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c45913e2-5b82-4d28-8ead-4243678a0b99"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 96.05,
    cy: 95.26,
    r: 12,
    style: {
      fill: "#e60000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.06,98.59a4.21,4.21,0,0,1,3-7.19h44.22a4.21,4.21,0,1,1,0,8.42H108A4.21,4.21,0,0,1,105.06,98.59Z",
    transform: "translate(0 0)",
    style: {
      fill: "#e60000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.69,98.43l-44.24,0a4.09,4.09,0,0,1-.85-.09,12.15,12.15,0,0,1-.74,1.49l.18,0h44.24a4.18,4.18,0,0,0,3.6-2A4,4,0,0,1,153.69,98.43Z",
    transform: "translate(0 0)",
    style: {
      opacity: 0.119999997317791,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,102.33a12,12,0,0,1-.71-16.26l-.71.7a12,12,0,0,0,17,17,5.87,5.87,0,0,0,.71-.7A12,12,0,0,1,89,102.33Z",
    transform: "translate(0 0)",
    style: {
      opacity: 0.119999997317791,
      isolation: "isolate"
    }
  })))))))), /*#__PURE__*/React.createElement("path", {
    d: "M88,104.16a12,12,0,0,0,16.53-.42,5.87,5.87,0,0,0,.71-.7l-.22.17a12.1,12.1,0,0,0,2.16-3.48,3.82,3.82,0,0,0,.68.07h0l.18,0h44.24a4.18,4.18,0,0,0,3.6-2l0,0a4.2,4.2,0,0,0,.64-2.21,4.14,4.14,0,0,0-1-2.72h0L174,111.44a79.32,79.32,0,0,1-18.12,36.87l-.14.15a79.68,79.68,0,0,1-12.17,11.26L87.42,103.6",
    transform: "translate(0 0)",
    style: {
      opacity: 0.100000001490116,
      isolation: "isolate",
      fill: "url(#linear-gradient-2)"
    }
  })));
}

var _default = ic_acceleration_hi__dark;
exports.default = _default;